
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import { postColorTailwindClass } from 'bits/post_color'
import type { Post } from 'types'

@Component({ components: { OzBaseButton, OzIcon } })
export default class SurfacePostAttachmentButton extends Vue {
  @Prop() post!: Post
  @Prop() iconName!: 'play' | 'download'
  @Getter colorScheme!: 'light' | 'dark'

  get isLightColorScheme(): boolean {
    return this.colorScheme == 'light'
  }
  get postColorClass(): string {
    return postColorTailwindClass({ postColor: this.post.color, isLightColorScheme: this.isLightColorScheme })
  }

  get buttonColorClass(): string {
    switch (this.post.color) {
      case 'red':
        return 'bg-scarlet-600'
      case 'orange':
        return this.isLightColorScheme ? 'bg-canary-600' : 'bg-tangerine-600'
      case 'green':
        return 'bg-park-600'
      case 'blue':
        return 'bg-oceanic-600'
      case 'purple':
        return 'bg-grape-600'
      default:
        return 'bg-dark-ui-200'
    }
  }

  get buttonHoverColorClass(): string {
    switch (this.post.color) {
      case 'red':
        return 'hover-hover:hover:bg-scarlet-500'
      case 'orange':
        return this.isLightColorScheme ? 'hover-hover:hover:bg-canary-500' : 'hover-hover:hover:bg-tangerine-500'
      case 'green':
        return 'hover-hover:hover:bg-park-500'
      case 'blue':
        return 'hover-hover:hover:bg-oceanic-500'
      case 'purple':
        return 'hover-hover:hover:bg-grape-500'
      default:
        return 'hover-hover:hover:bg-dark-ui-300'
    }
  }

  get buttonIconColorClass(): string {
    switch (this.post.color) {
      case 'red':
        return 'text-scarlet-200'
      case 'orange':
        return this.isLightColorScheme ? 'text-canary-200' : 'text-tangerine-200'
      case 'green':
        return 'text-park-200'
      case 'blue':
        return 'text-oceanic-200'
      case 'purple':
        return 'text-grape-200'
      default:
        return 'text-light-text-200'
    }
  }
}
